import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { IProps } from './types';

const OptOutConfirmation = ({ open, onClose, onConfirm }: IProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: 460,
          borderRadius: 3,
          p: 0,
          boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 600,
          fontSize: '1.1rem',
          pb: 1,
          pt: 2,
          px: 3,
        }}
      >
        Confirm Opt-Out
      </DialogTitle>

      <DialogContent
        sx={{
          px: 3,
          pb: 1,
        }}
      >
        <Typography
          sx={{
            fontSize: '0.95rem',
            color: 'text.secondary',
          }}
        >
          Are you sure you want to opt out of SMS notifications for this phone number?
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: 1.5,
          px: 3,
          py: 2,
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            textTransform: 'none',
            fontWeight: 500,
            borderRadius: '8px',
            px: 2.5,
            py: 0.8,
            minWidth: '90px',
            borderColor: '#bdbdbd',
            color: '#424242',
            '&:hover': {
              backgroundColor: '#f5f5f5',
              borderColor: '#9e9e9e',
            },
          }}
        >
          Cancel
        </Button>

        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: '8px',
            px: 2.5,
            py: 0.8,
            minWidth: '90px',
            boxShadow: '0 2px 6px rgba(244, 67, 54, 0.3)',
            transition: 'all 0.25s ease-in-out',
            '&:hover': {
              boxShadow: '0 4px 10px rgba(244, 67, 54, 0.4)',
              transform: 'translateY(-1px)',
            },
          }}
        >
          Opt Out
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OptOutConfirmation;
